export default __webpack_public_path__ + "static/card-pointers-logo-f073e61cba4b3331504290befdb16497.svg";